import React, { useEffect, useState } from 'react';
import colors from '../../../../../util/colors';
import './styles.scss';
import Icon from '../../../../../components/icon';
import { Icons } from '../../../../../util/icons';
import { Column, Row } from '../../../../../components/layout';
import * as fonts from '../../../../../util/fonts';
import { strings } from '../../../../../util/strings';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  addToGlobalStyles,
  addToWizard,
  setWizard,
} from '../../../../../store/actions';
import AttachFiles from './attach-files';
import ReimbursementSubmissionStatusBar from '../../../components/ReimbursementSubmissionStatusBar';
import ModalTemplate from '../../../../../components/modal';
import { useHistory } from 'react-router-dom';
import AppButton from '../../../../../components/app-button';

export interface InvoiceValidationProps {
  onSubmit(values: any): any;
  setValid(value: boolean): void;
  nextStep(): void;
  valid: boolean;
  wizard: any;
  setWizard(value: any): void;
  addToWizard(value: any): void;
  addToGlobalStyles(value: any): void;
  labels: typeof strings.pt.createRefund;
  labelsPreAuthorizations: typeof strings.pt.preAuthorizations;
  showPopup: boolean;
  titleOfButton: string;
  selectedBu: any;
  nextStepFlag: boolean;
  labelFiles?: string;
  preAuth?: boolean;
  patients?: any;
  documentTypes?: any;
}

function InvoiceValidation(props: InvoiceValidationProps) {
  const {
    labels,
    wizard,
    nextStep,
    showPopup,
    titleOfButton,
    selectedBu,
    nextStepFlag,
    labelFiles = labels?.createRefund_sendReceiptText,
    labelsPreAuthorizations,
  } = props;
  const [sessionId, setSessionId] = useState<string>();
  const [totalSteps, setTotalSteps] = useState();
  const [errorShow, setErrorShow] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const history = useHistory();

  if (!!wizard.attachFiles && !!!sessionId) {
    setSessionId(wizard.attachFiles.sessionId);
  }

  return !!sessionId ? (
    <>
      <p style={{...fonts.L, ...fonts.Bold, color: colors.black}}>
        {labels?.createRefund_readingInProgress}
      </p>
      <Column className="invoice justify-content-center pt-2">
        <div className="container pt-5">
          <Icon
            changeViewbox={false}
            name={Icons.CLOCK}
            color={colors.black}
            width="40"
            height="40"
          />
          <Row className="pt-3 justify-content-center">
            <Column className="pb-5">
              <p className="notification-text pb-5" style={{...fonts.MM}}>
                {labels?.createRefund_notification}
              </p>

              <Row className="justify-content-center">
                <ReimbursementSubmissionStatusBar
                  sessionId={sessionId}
                  ReimbursementFinishedSubmitting={(values) => {
                    if (values.errorCode > 0) {
                      setErrorShow(true);
                      setErrorMessage(values.errorMessage);
                    } else {
                      props.addToWizard({
                        invoiceValidation: values.metadata,
                      });
                      nextStep();
                    }
                  }}
                />
              </Row>
            </Column>
          </Row>
        </div>
        {errorShow && (
          <ModalTemplate
            type="error"
            show={errorShow}
            hideFooter={true}
            onHide={() => {
              setErrorShow(false);
              history.push('/historico-reembolsos');
            }}
            cross={true}>
            <p style={{...fonts.Bold, color: colors.alertRed}}>
              {labels?.createRefund_errorOnReading}
            </p>
            <p>{errorMessage || labels?.createRefund_tryLater}</p>
            <Row>
              <AppButton
                onClick={async () => {
                    setWizard({});
                    history.push('/historico-reembolsos');
                }}
                variant="secondary"
                className="talk-with-us-modal-button">
                Ok
              </AppButton>
            </Row>
          </ModalTemplate>
        )}
      </Column>
    </>
  ) : (
    <AttachFiles
      {...props}
      titleOfButton={titleOfButton}
      showPopup={showPopup}
      nextStep={nextStep}
      selectedBu={props.selectedBu.buId}
      nextStepFlag={nextStepFlag}
      labelFiles={labelFiles}
    />
  );
}

const mapStateToProps = ({ wizard, strings, selectedBu }: any) => ({
  wizard: wizard.value,
  labels: strings.value.pt.createRefund,
  labelsPreAuthorizations: strings.value.pt.preAuthorizations,
  selectedBu: selectedBu.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
  addToGlobalStyles: (value: any) => dispatch(addToGlobalStyles(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(InvoiceValidation)
);
